<template>
    <v-container fluid>
        <v-card :loading="loading" class="elevation-3">
            <div class="card-title">{{ $t('EmailAudit') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-text-field v-model="search"
                                  class="me-8"
                                  append-icon="mdi-magnify"
                                  :label="$t('Search')"
                                  single-line
                                  hide-details />
                    <v-spacer />
                </v-card-title>
                <v-data-table :headers="headers"
                              dense
                              :items="EmailAudit"
                              :search="search"
                              class="mt-6">
                    <template v-slot:[`item.sendTo`]="{ item }">
                        {{ item.sendTo }}
                    </template>
                    <template v-slot:[`item.emailSubject`]="{ item }">
                        {{item.emailSubject}}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <table>
                            <tr>
                                <td style="padding:10px">
                                    <v-btn color="primary" @click="previewEmail(item.emailBody)" small>
                                        {{ $t('Preview') }}
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                    </template>
                </v-data-table>
                <v-dialog v-model="previewDialog" max-width="800px">
                    <v-card>
                        <v-card-title class="headline">{{ previewTitle }}</v-card-title>
                        <v-card-text>
                            <div v-html="previewContent"></div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="primary" text @click="previewDialog = false">
                                {{ $t('Close') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-text>
        </v-card>
    </v-container></template>
<script>
    import { mapGetters } from 'vuex'
    import EmailTemplatesService from '@/services/EmailTemplatesService.js'

    export default {
        components: {
            
        },
        data() {
            return {
                search: '',
                selectedTemplateId: 0,
                loading: false,
                enabled: false,
                EmailAudit: [],
                mainSurveyList: [],
                userPermissionsList: [],

                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('SendTo'), value: 'sendTo', width: '15%' },
                    { text: this.$t('Date'), value: 'date', width: '15%' },
                    { text: this.$t('EmailSubject'), value: 'emailSubject', width: '15%' },
                    { text: this.$t('Actions'), value: 'actions' }
                ],
                selectedItem: null,
                selectedTitle: '',
                previewDialog: false,
                previewContent: '',
                previewTitle: ''
            }
        },

        created() {
            this.listEmailAudit()
        },

        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language
            }
        },

        methods: {

            listEmailAudit() {
                this.loading = true
                EmailTemplatesService.listEmailAudit()
                    .then((res) => {
                        this.EmailAudit = res.data.map(item => {
                            item.date = this.formatDate(item.date)
                            return item
                        })
                    })
                    .catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            previewEmail(body) {
                this.previewContent = body
                this.previewTitle = this.$t('EmailPreview')
                this.previewDialog = true
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                const hours = String(date.getHours()).padStart(2, '0')
                const minutes = String(date.getMinutes()).padStart(2, '0')
                const seconds = String(date.getSeconds()).padStart(2, '0')
                const time = `${hours}:${minutes}:${seconds}`

                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                const formattedDate = `${year}-${month}-${day}`

                return `${time}, ${formattedDate}`
            }
        }
    }
</script>
<style scoped>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #fff
    }
</style>
